<template>
    <div>
        <div class="table-responsive">
            <table class="table table-hover table-bordered table-sm">
                <thead class="thead-orange">
                    <tr>
                        <th>Usuario</th>
                        <th>Estado de la petición</th>
                        <th>Comentario</th>
                        <th>Fecha creación</th>
                        <th>Accion</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="(comment, i) in comments"
                        class="x-d-flex"
                        :key="i"
                    >
                        <template v-if="!!comment.editing">
                            <td>{{ comment.user.name }}</td>
                            <td>{{ comment.petition_status.name }}</td>
                            <td>
                                <app-form-textarea-input
                                    placeholder="Comentario"
                                    id="comment"
                                    v-model="comment.comment"
                                    :hasError="$v.comment.comment.$error"
                                    errorMessage="Escriba el comentario"
                                    @input="$v.comment.comment.$touch()"
                                />
                            </td>
                            <td>{{ comment.created_at | datetime }}</td>
                            <td>
                                <b-btn
                                    size="sm"
                                    variant="danger"
                                    @click="editComment(comment, false)"
                                    ><i
                                        class="fa fa-times"
                                        aria-hidden="true"
                                    ></i
                                ></b-btn>
                                <b-btn
                                    size="sm"
                                    variant="success"
                                    @click="confirmEdition(comment)"
                                    ><i
                                        class="fa fa-check"
                                        aria-hidden="true"
                                    ></i
                                ></b-btn>
                            </td>
                        </template>
                        <template v-else>
                            <td>{{ comment.user.name }}</td>
                            <td>{{ comment.petition_status.name }}</td>
                            <td>{{ comment.comment }}</td>
                            <td>{{ comment.created_at | datetime }}</td>
                            <td v-if="!comment.public">
                                <app-btn-confirm
                                    @confirm="publishComment(comment)"
                                    variant="primary"
                                    v-if="userCan('public-pqr-comments')"
                                >
                                    Publicar
                                </app-btn-confirm>
                            </td>
                            <td v-else>
                                <span
                                    ><b-alert show variant="success"
                                        >Público</b-alert
                                    ></span
                                >
                            </td>
                            <td v-if="user.id === comment.user.id">
                                <div v-if="withActions">
                                    <b-btn
                                        size="sm"
                                        variant="info"
                                        @click="editComment(comment, true)"
                                        ><i
                                            class="fa fa-pencil"
                                            aria-hidden="true"
                                        ></i
                                    ></b-btn>
                                    <b-btn
                                        size="sm"
                                        class="ml-2"
                                        :disabled="inProgress"
                                        variant="danger"
                                        @click="removeComment(comment)"
                                        ><i
                                            class="fa fa-times"
                                            aria-hidden="true"
                                        ></i
                                    ></b-btn>
                                </div>
                            </td>
                            <td v-else></td>
                        </template>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import petitionsRepository from "../../../repositories/petitions.repository.js";
export default {
    props: {
        comments: {
            type: Array,
            default: []
        },
        onRemove: {
            type: Function
        },
        withActions: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            comment: {
                comment: ""
            }
        };
    },
    validations: {
        comment: {
            comment: { required }
        }
    },
    computed: {
        inEdition() {
            return !!this.comments.filter(item => !!item.editing).length;
        }
    },
    methods: {
        async publishComment(comment) {
            const { data } = await repo.post(
                `petitions/${comment.id}/change-status-comment`
            );
            if (data.status) {
                toastr.success(data.msg);
                this.$bus.$emit("loadPetitions");
                this.$bus.$emit(
                    "view-comments-petition-resolved-petitions.close"
                );
            } else {
                toastr.error(data.msg);
            }
        },
        editComment(comment, state) {
            const comm = { ...comment, editing: state };
            const index = this.comments.findIndex(
                item => item.id === comment.id
            );

            if (-1 !== index) {
                this.comments.splice(index, 1, comm);
                this.comment = { ...comment };
            }
        },
        confirmEdition(comment) {
            const pr = { ...petitionsRepository };
            pr.updateComment(comment, comment.id)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg);
                        Object.keys(this.comment).map(
                            key => (this.comment[key] = "")
                        );
                        this.editComment(comment, false);
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error("No se pudo modificar el comentario");
                });
        },
        removeComment(comment) {
            const pr = { ...petitionsRepository };
            pr.removeComment(comment.id)
                .then(data => {
                    if (data.status) {
                        const i = this.comments.indexOf(comment);
                        this.comments.splice(i, 1);
                        toastr.success(data.msg);
                        typeof this.onRemove === "function" && this.onRemove();
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error("No se pudo borrar el comentario");
                });
        }
    }
};
</script>
